import './SonarAvatar.scss';
import classNames from 'classnames';
import React from 'react';
import { UserOutlined } from '@ant-design/icons';
import { Avatar, AvatarProps } from 'antd';

export interface SonarAvatarProps extends AvatarProps {
	large?: boolean;
	isPlaceholder?: boolean;
}

export const SonarAvatar: React.FC<SonarAvatarProps> = ({ children, className, large, isPlaceholder, ...rest }) => {
	if (isPlaceholder) {
		const placeholderClassName = classNames('placeholder-avatar', className, { large });

		return <Avatar
			className={ placeholderClassName }
			icon={ <UserOutlined /> } />;
	}

	const avatarClassName = classNames('sonar-avatar', className, { large });

	return (
		<Avatar
			className={ avatarClassName }
			{ ...rest }>
			{ children }
		</Avatar>
	);
};
